import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Quiz = ({ currentQuestionNum, questionLength, question, submitAnswers }) => {
  const [selectedChoices, setSelectedChoices] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.zoom = '1';
  }, []);

  const handleChoiceClick = (choice) => {
    setSelectedChoices(prev => {
      if (prev.includes(choice)) {
        return prev.filter(c => c !== choice);
      } else {
        return [...prev, choice];
      }
    });
  };

  // 問題文内のコードブロックを表示する関数
  const renderCode = (code) => {
    if (!code || code.length === 0) return null;
    return (
      <pre>
        <code className="java">
          {code.map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {'\n'}
            </React.Fragment>
          ))}
        </code>
      </pre>
    );
  };

  return (
    <div className="quiz-container card">
      <header className="quiz-header">
        <h1>問題 No.{question.number}</h1>
        <div className="quiz-progress">
          <progress value={currentQuestionNum} max={questionLength} />
          <div>{currentQuestionNum}/{questionLength}問</div>
        </div>
      </header>

      <div className="question-content">
        {question['previous-code'] && renderCode(question['previous-code'])}
        
        <p className="question-text">{question.question}</p>
        
        {question['following-code'] && renderCode(question['following-code'])}

        {question.jpnURL && (
          <a href={question.jpnURL} className="reference-link" target="_blank" rel="noopener noreferrer">
            参考問題ページ
          </a>
        )}

        <div className="question-choices">
          {question.choices.map((choice, index) => (
            choice && (
              <div
                key={index}
                className={`choice-item ${selectedChoices.includes(choice) ? 'selected' : ''}`}
                onClick={() => handleChoiceClick(choice)}
              >
                <span className="choice-label">{String.fromCharCode(65 + index)}.</span>
                {choice}
              </div>
            )
          ))}
        </div>

        <div className="action-buttons">
          <button
            onClick={() => submitAnswers(selectedChoices)}
            className="button"
            disabled={selectedChoices.length === 0}
          >
            回答する
          </button>
        </div>
      </div>
    </div>
  );
};

Quiz.propTypes = {
  currentQuestionNum: PropTypes.number.isRequired,
  questionLength: PropTypes.number.isRequired,
  question: PropTypes.shape({
    number: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    choices: PropTypes.arrayOf(PropTypes.string).isRequired,
    'previous-code': PropTypes.arrayOf(PropTypes.string),
    'following-code': PropTypes.arrayOf(PropTypes.string),
    jpnURL: PropTypes.string
  }).isRequired,
  submitAnswers: PropTypes.func.isRequired
};

export default Quiz;
